'use strict';

var _ = require('lodash');
var WhatIfRowDetailsController = function WhatIfRowDetailsController($scope, $rootScope) {
  $scope.showReadOnlyRule = function (rule) {
    $rootScope.$broadcast('whatIfResults:showModal', rule);
  };
};
WhatIfRowDetailsController.$inject = ['$scope', '$rootScope'];
module.exports = WhatIfRowDetailsController;